import { DEFAULT_LIMIT_OF_MESSAGES_LOADING } from 'APP/model/message/messageModel.constants';
import { IMessage } from 'APP/model/message/messageModel.types';
import Entities from 'STORE';

export function handleIsLoadedFirstMessages(groupId: string, messages: IMessage[]): void {
  const group = Entities.GroupsStore.getGroupById(groupId);

  if (!group || group.isFake) {
    return;
  }

  if (messages.length < DEFAULT_LIMIT_OF_MESSAGES_LOADING) {
    group.messagesStore.setLoadedFirstMessages(true);
  }
}
